import { apiPost, apiDelete } from './client';
import { ApiResponse } from '@tinyrewards/shared';

export interface DesignMessage {
    sessionId: string;
    message: string;
    imageUrl: string | null;
}

export function startDesignSession(data: {
    badgeName?: string;
    badgeDescription?: string;
}): Promise<ApiResponse<DesignMessage>> {
    return apiPost<DesignMessage>('/api/badge-design/start', data);
}

export function sendDesignMessage(data: {
    sessionId: string;
    message: string;
}): Promise<ApiResponse<DesignMessage>> {
    return apiPost<DesignMessage>('/api/badge-design/message', data);
}

export function closeDesignSession(sessionId: string): Promise<ApiResponse<null>> {
    return apiDelete<null>(`/api/badge-design/${sessionId}`);
}
